import { forgotPassword, InvalidInput } from '@trippath/shared';
import { useId, useState, type SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

/** A forgotten password (the `ShareLink` mockup's first step): a link to set a new one mailed. */
export function Forgot() {
  const { t } = useTranslation();
  const ids = useId();
  const [email, setEmail] = useState('');
  const [said, setSaid] = useState<'sent' | 'noMail' | null>(null);
  const [failed, setFailed] = useState(false);
  const submit = (event: SyntheticEvent) => {
    event.preventDefault();
    setFailed(false);
    forgotPassword(email).then(
      (mail) => {
        setSaid(mail ? 'sent' : 'noMail');
      },
      (error: unknown) => {
        setFailed(!(error instanceof InvalidInput));
      },
    );
  };
  return (
    <div className="page sign-in">
      <form className="panel form" onSubmit={submit} aria-labelledby={`${ids}-title`}>
        <h1 id={`${ids}-title`}>{t('reset.title')}</h1>
        <p className="quiet">{t('reset.lead')}</p>
        <div className="field">
          <label className="field-label" htmlFor={`${ids}-email`}>
            {t('reset.email')}
          </label>
          <input
            id={`${ids}-email`}
            className="text-input"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
        </div>
        <button type="submit" className="button button-primary">
          {t('reset.send')}
        </button>
        {said && (
          <p className="ok-msg" role="status">
            {t(`reset.${said}`)}
          </p>
        )}
        {failed && (
          <p className="form-failed" role="alert">
            {t('trips.failed')}
          </p>
        )}
        <Link to="/">{t('reset.back')}</Link>
      </form>
    </div>
  );
}
